import React from 'react';
import { SuccessModal, SuccessModalProps } from '@common-fe/common-fe';

import useAutoBlockedModal from './hooks/useAutoBlockedModal';

const SuccessAutoBlockedModal: React.FC<SuccessModalProps> = (props) => {
  const { isClosingByClickOutsideBlocked } = useAutoBlockedModal({ visible: props?.visible });

  return (
    <SuccessModal
      {...props}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked || props?.isClosingByClickOutsideBlocked}
    />
  );
};

export default SuccessAutoBlockedModal;
